<template>
<v-overlay
    opacity="0.3"
    :value="show"
    z-index="10"
>
    <v-row
        v-if="text"
    >
        <v-col>
            <div
                class="text-h3"
                style="text-align: center;"
            >
                {{text}}
            </div>
        </v-col>
    </v-row>
    <v-row
        style="text-align: center"
    >
        <v-col>
            <v-progress-circular
                :size="70"
                color="primary"
                indeterminate
            />
        </v-col>
    </v-row>


</v-overlay>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            text: null,
        }
    },

    created () {
        this.$event_bus.$on('show-spinner', this.showSpinner);
        this.$event_bus.$on('hide-spinner', this.hideSpinner);
    },

    beforeDestroy () {
        this.$event_bus.$off('show-spinner',this.showSpinner);
        this.$event_bus.$off('hide-spinner',this.hideSpinner);
    },

    methods: {
        
        showSpinner(text) {
            this.show = true;
            this.text = text;
        },

        hideSpinner() {
            this.show = false;
            this.text = null;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>